import { KeyReturn } from '@phosphor-icons/react';
import React, { Dispatch, SetStateAction, useRef } from 'react';
import { Conversation } from '../../../../@types/IA.type';

const ChatInput = ({
	setShowMessages,
	isLoading,
	userMessage,
	setUserMessage,
	handleSubmit,
}: {
	showMessages: boolean;
	setShowMessages: (showMessages: boolean) => void;
	isLoading: { completion: boolean };
	setCurrentThread: Dispatch<SetStateAction<Conversation>>;
	chatHistory: Conversation[];
	getMessageHistory: () => Promise<void>;
	userMessage: string;
	setUserMessage: (userMessage: string) => void;
	handleSubmit: (
		message: string,
		e?: React.FormEvent<HTMLFormElement | HTMLTextAreaElement>,
	) => Promise<void>;
}) => {
	const textareaRef = useRef<HTMLTextAreaElement>(null);
	const adjustHeight = () => {
		const textarea = textareaRef.current;
		if (textarea) {
			textarea.style.height = '0px';
			const minHeight = 40;
			const scrollHeight = Math.max(textarea.scrollHeight, minHeight);
			textarea.style.height = scrollHeight + 'px';
		}
	};

	const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		setUserMessage(e.target.value);
		setTimeout(adjustHeight, 0);
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
		if (e.key === 'Enter' && !e.shiftKey && !isLoading.completion) {
			e.preventDefault();
			handleSubmit(userMessage, e);
			setTimeout(adjustHeight, 0);
		}
	};

	return (
		<form
			onSubmit={(e) => handleSubmit(userMessage, e)}
			className='p-2 flex items-center gap-1'
		>
			<textarea
				ref={textareaRef}
				placeholder='Escribe tu consulta aquí'
				className={`md:text-sm text-base rounded-3xl overflow-hidden py-2 px-3 outline-none w-full resize-none min-h-[40px] font-light border border-h-primary bg-transparent`}
				onChange={handleInputChange}
				onKeyDown={handleKeyDown}
				value={userMessage}
				rows={1}
				onFocus={() => setShowMessages(true)}
				maxLength={1000}
			/>
			<button
				className='p-1 rounded-2xl bg-h-primary-90/50 hover:bg-h-primary-90'
				type='submit'
				disabled={isLoading.completion}
			>
				<KeyReturn
					size={32}
					className='text-h-primary'
					weight='fill'
				/>
			</button>
		</form>
	);
};

export default ChatInput;
